import React, { useEffect, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { MenuConfig } from 'commonTypes'
import useMenuItemStyles from './MenuItem.styles'
import MenuIcons, { MenuIconTypes } from '../icons/MenuIcons'

type Props = {
    name: string
    isMenuOpen: boolean
    isTabletView: boolean
    iconSrc: string
    route: string
    subMenu: Array<MenuConfig>
    isActive: boolean
    selectedSubmenu: string
    setSelectedSubmenu: (submenu: string) => void
}

const MenuItem: React.FC<Props> = ({
    name,
    isMenuOpen,
    isTabletView,
    route,
    subMenu,
    isActive,
    selectedSubmenu,
    setSelectedSubmenu
}) => {
    const styles = useMenuItemStyles()
    const location = useLocation()
    const rootUrlRegexp = useMemo(() => /\/patients\/\d+\/report\/\d+$/, [])
    const itemName = isMenuOpen ? name : ''

    useEffect(() => {
        if (!rootUrlRegexp.test(location.pathname)) {
            setSelectedSubmenu('compounds')
        }
    }, [location, rootUrlRegexp, setSelectedSubmenu])

    return (
        <div>
            <Link to={route} state={{ shouldReloadMenu: true }}>
                <div
                    className={`${styles.menuItem} ${
                        isActive ? styles.active : ''
                    }`}
                >
                    <MenuIcons
                        type={name as MenuIconTypes}
                        className={styles.image}
                    />
                    <div
                        className={`${styles.itemName} ${
                            isActive ? styles.active : ''
                        }`}
                    >
                        {isTabletView ? '' : itemName}
                    </div>
                </div>
            </Link>
            {!isTabletView && (
                <div>
                    {subMenu.map((subMenuItem) => {
                        const { id, scrollTo, name, show } = subMenuItem
                        const isSubmenuItemActive = selectedSubmenu === scrollTo
                        return (
                            isMenuOpen &&
                            show && (
                                <Link
                                    to={route}
                                    state={{
                                        scrollTo,
                                        shouldReloadMenu: false
                                    }}
                                    key={id}
                                >
                                    <div
                                        className={`${styles.subMenuItem} ${
                                            isSubmenuItemActive
                                                ? styles.active
                                                : ``
                                        }`}
                                        onClick={() =>
                                            setSelectedSubmenu(scrollTo)
                                        }
                                    >
                                        <div
                                            className={`${styles.subItemName} ${
                                                isSubmenuItemActive
                                                    ? styles.active
                                                    : ``
                                            }`}
                                        >
                                            {name}
                                        </div>
                                    </div>
                                </Link>
                            )
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default MenuItem
